import React from 'react';

import i18n from '../../i18n';

// @mui
import {
    TableCell,
} from '@mui/material';

import Label from '../../components/label';

export default class GridStatusCell extends React.Component {

    render() {
        // props: value, id, field
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                <Label color={this.props.value ? 'success' : 'error'} dot="solid">
                    {this.props.value ? i18n.t("values.active") : i18n.t("values.disabled")}
                </Label>
            </TableCell>
        );
    }

}
